import React from 'react';
export function ScenarioTabs() {
  return <div className="flex border-b border-gray-200 mt-2" data-id="element-140">
      <button className="px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300" data-id="element-141">
        Good
      </button>
      <button className="px-4 py-2 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-142">
        Better
      </button>
      <button className="px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-700 hover:border-gray-300" data-id="element-143">
        Best
      </button>
    </div>;
}